// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item-divider {
  min-height: 74px;
}

.line-breaker {
  white-space: pre-line;
}

.container .message {
  position: relative;
  padding: 7px 0;
}
.container .message .msg-content {
  color: white;
}
.container .message .left-mgs {
  border-radius: 8px 8px 8px 0px;
  background-color: var(--ion-color-dark, black);
  float: left;
  padding: 10px;
  max-width: 85%;
}
.container .message .right-msg {
  border-radius: 8px 8px 0px 8px;
  background-color: var(--ion-color-tertiary);
  float: right;
  padding: 10px;
  max-width: 85%;
}
.container .message .right {
  font-size: 10px;
  float: right;
  padding: 10px 0px 0px 0px;
}
.container .message .user-img {
  position: absolute;
  border-radius: 45px;
  width: 45px;
  height: 45px;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.36);
}
.container .message .msg-detail {
  padding: 0px 15px;
  display: inline-block;
  width: 100%;
}
.container .message .msg-detail p {
  margin: 0;
}
.container .message .msg-detail .msg-info p {
  font-size: 0.8em;
  color: #888;
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/messages-core/lib/components/gbm-item-open/gbm-item-open.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAGE;EACE,kBAAA;EACA,cAAA;AAAJ;AAEI;EACE,YAAA;AAAN;AAGI;EACE,8BAAA;EACA,8CAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;AADN;AAII;EACE,8BAAA;EACA,2CAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;AAFN;AAKI;EACE,eAAA;EACA,YAAA;EACA,yBAAA;AAHN;AAMI;EACE,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,uCAAA;AAJN;AAOI;EACE,iBAAA;EACA,qBAAA;EACA,WAAA;AALN;AAMM;EACE,SAAA;AAJR;AAOQ;EACE,gBAAA;EACA,WAAA;AALV","sourcesContent":["ion-item-divider {\n  min-height: 74px;\n}\n\n.line-breaker {\n  white-space: pre-line;\n}\n\n.container {\n  .message {\n    position: relative;\n    padding: 7px 0;\n\n    .msg-content {\n      color: white;\n    }\n\n    .left-mgs {\n      border-radius: 8px 8px 8px 0px;\n      background-color: var(--ion-color-dark, black);\n      float: left;\n      padding: 10px;\n      max-width: 85%;\n    }\n\n    .right-msg {\n      border-radius: 8px 8px 0px 8px;\n      background-color: var(--ion-color-tertiary);\n      float: right;\n      padding: 10px;\n      max-width: 85%;\n    }\n\n    .right {\n      font-size: 10px;\n      float: right;\n      padding: 10px 0px 0px 0px;\n    }\n\n    .user-img {\n      position: absolute;\n      border-radius: 45px; //????\n      width: 45px;\n      height: 45px;\n      box-shadow: 0 0 2px rgba(0, 0, 0, 0.36);\n    }\n\n    .msg-detail {\n      padding: 0px 15px;\n      display: inline-block;\n      width: 100%;\n      p {\n        margin: 0;\n      }\n      .msg-info {\n        p {\n          font-size: 0.8em;\n          color: #888;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
